import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-731608a8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "upper" }
const _hoisted_4 = { class: "section" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Home ")
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Solutions ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Products ")
const _hoisted_8 = { class: "section" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" About ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Contacts ")
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" Career ")
const _hoisted_12 = { class: "count" }
const _hoisted_13 = { class: "section" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" Booklet ")
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Exhibitions ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" Partners ")
const _hoisted_17 = { class: "section" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item" }, " Contacts ", -1))
const _hoisted_19 = { class: "item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Business:", -1))
const _hoisted_21 = { class: "item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Career:", -1))
const _hoisted_23 = /*#__PURE__*/_createStaticVNode("<div class=\"lower\" data-v-731608a8><div class=\"hash\" data-v-731608a8> #FollowThatAardvark </div><div class=\"socials\" data-v-731608a8><a class=\"link\" href=\"https://linkedin.com/company/advbet\" target=\"_blank\" data-v-731608a8><span class=\"icon linkedin\" data-v-731608a8></span></a><a class=\"link\" href=\"https://instagram.com/adv.bet\" target=\"_blank\" data-v-731608a8><span class=\"icon instagram\" data-v-731608a8></span></a><a class=\"link\" href=\"https://www.facebook.com/aardvarktechnologies/\" target=\"_blank\" data-v-731608a8><span class=\"icon facebook\" data-v-731608a8></span></a></div></div>", 1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            class: "item link",
            to: "/"
          }, {
            default: _withCtx(() => [
              _hoisted_5
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "item link",
            to: "/solutions"
          }, {
            default: _withCtx(() => [
              _hoisted_6
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "item link",
            to: "/products"
          }, {
            default: _withCtx(() => [
              _hoisted_7
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_router_link, {
            class: "item link",
            to: "/about"
          }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "item link",
            to: "/contacts"
          }, {
            default: _withCtx(() => [
              _hoisted_10
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "item link",
            to: "/career"
          }, {
            default: _withCtx(() => [
              _hoisted_11,
              _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.positions.length), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_router_link, {
            class: "item link",
            to: "/booklet"
          }, {
            default: _withCtx(() => [
              _hoisted_14
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "item link",
            to: "/exhibitions"
          }, {
            default: _withCtx(() => [
              _hoisted_15
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            class: "item link",
            to: "/partners"
          }, {
            default: _withCtx(() => [
              _hoisted_16
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createTextVNode(" " + _toDisplayString(_ctx.businessEmail), 1)
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createTextVNode(" " + _toDisplayString(_ctx.careerEmail), 1)
          ])
        ])
      ]),
      _hoisted_23
    ])
  ]))
}